import { useState } from "react";
import styles from "../styles/Products.module.css"
import { Button } from '@chakra-ui/react'
// import { json } from "react-router-dom";
import { useToast ,Box} from '@chakra-ui/react'
import { Link } from "react-router-dom";
import {motion} from "framer-motion"
function ShowData({data}){


// console.log(data);


let [curData, setData] = useState(data)
console.log(curData);
function changeData(type){
    if(type === "low-high"){
         
        curData.sort((e1,e2)=>{
            return Number(e1.price) - Number(e2.price)
        })
        console.log(curData);
        let Data = [ ...curData]
        setData(Data)
    }
    if(type === "high-low"){
        // let Data = curData
        
        curData.sort((e1,e2)=>{
            return Number(e2.price) - Number(e1.price)
        })
        console.log(curData);
        let Data = [ ...curData]
        setData(Data)
    }
    if(type === "Blue"){
        // let Data = curData
     
        let res = curData.filter((el)=>el.color === "Blue")
        console.log(res);
        // let Data = [ ...curData]
        setData(res)
    }
    if(type === "Brown"){
        // let Data = curData
        
        let res = curData.filter((el)=>el.color === "Brown")
        console.log(res);
        // let Data = [ ...curData]
        setData(res)
    }

    // console.log(type);
}
const toast = useToast()

let cartData = JSON.parse(localStorage.getItem("cartData")) || []
function addtocart(product){
    let flag = true;
    cartData.forEach(element => {
        if(element.id === product.id){
            flag=false
            console.log(element, product);
        }
    });
    
    if(flag){
        product.quantity=1;
        cartData.push(product)
        localStorage.setItem("cartData",JSON.stringify(cartData))
        toast({

            render: () => (
              <Box color='white' p={3} bg='blue.500'>
                 Product Added To Cart
              </Box>
            )
          })
    }else{
        toast({
            render: () => (
              <Box color='white' p={3} bg='blue.500'>
                 Product is already in Cart
              </Box>
            )
          })

    }

  
}

return(
    
        <div 
      
        className={styles.showPage}>
            <motion.div 
              initial={{
                x: "-100vh"
            }}
            animate={{
                x:"0vh"
            }} className={styles.fDiv}>
                <h2>FILTERS</h2>
                <div className={styles.filtersDiv}>
                <div className={styles.filters}>
                    <input name="sort" onChange={(e)=> {changeData("low-high")}} type="radio" />
                    <label>low - high</label>
                </div>
                <div  className={styles.filters}>
                    <input name="sort" onChange={(e)=> {changeData("high-low")}} type="radio" />
                    <label>high - low</label>
                </div>
                </div>
                <hr />
                <h2>COLORS</h2>
                <div className={styles.filters}>
                    <input onChange={(e)=> {changeData("Blue")}} type="checkbox" />
                    <label>Blue</label>
                </div>
                <div className={styles.filters}>
                    <input onChange={(e)=> {changeData("Brown")}} type="checkbox" />
                    <label>Brown</label>
                </div>
                <div className={styles.filters}>
                    <input type="checkbox" />
                    <label>Navy Blue</label>
                </div>
                <div className={styles.filters}>
                    <input type="checkbox" />
                    <label>Green</label>
                </div>
                <div className={styles.filters}>
                    <input type="checkbox" />
                    <label>Grey</label>
                </div>
                <hr />
                <h2>BRANDS</h2>
                <div className={styles.filters}>
                    <input type="checkbox" />
                    <label>Allen Solly</label>
                </div>
                <div className={styles.filters}>
                    <input type="checkbox" />
                    <label>JANISH</label>
                </div>
                <div className={styles.filters}>
                    <input type="checkbox" />
                    <label>HIGHLANDER</label>
                </div>
                <div className={styles.filters}>
                    <input type="checkbox" />
                    <label>AROww</label>
                </div>
                <div className={styles.filters}>
                    <input type="checkbox" />
                   <label>ShowOff</label>
                </div>
            </motion.div>
<motion.div
initial={{
                x: "+100vh"
            }}
            animate={{
                x:"0vh"
            }}
className={styles.products}>
            {
               curData.length > 0 ? curData.map((el,index)=>(
                    <motion.div 
                    whileHover={{scale: 1.1}}
                    key={index}>
                        <img src={el.image} alt="" />
                        <h3>{el.title}</h3>
                        <p>{el.description}</p>
                        <p>Rating: {el.rating}</p>
                        <p>Rs. {el.price}</p>
                        <p style={{color:"orange", fontSize:"x-smaller"}}>(53%OFF)</p>
                        <div style={{display:"flex", gap:"5px"}}>

                        <motion.div
                        whileHover={{scale: 1.1}}
                        >
                        <Button fontSize="sm" style={{backgroundColor:"#ff972c"}} onClick={()=>{addtocart(el)}} colorScheme='blue'>Add To Cart</Button>
                        </motion.div>
                        <motion.div
                        whileHover={{scale: 1.1}}
                        >
                        <Link to={`/product/${el.id}`}>
                        <Button  fontSize="sm"
                        onClick={()=>{addtocart(el)}} style={{backgroundColor:"#ffdc31"}} 
                        > Details</Button>

                        </Link>
                        </motion.div>
                            </div>
                    </motion.div>
                )
                ) : <h2>Products Not Found!</h2>
            }
{/* #ff972c  */}
        </motion.div>
        </div>
        
    )
}

export default ShowData;